// src/redux/reducers/index.js

import { combineReducers } from "redux";
import reviewsReducer from "./reviewsReducer";
import settingsReducer from "./settingsReducer";
import statsReducer from "./statsReducer";
import importReviewsReducer from "./importReviewsReducer";
import pricingsReducer from "./PricingReducer";
import integrationReducer from "./integrationReducer";
import questionsReducer from "./questionsReducer";
import onBoardingStepsReducer from "./onBoardingStepsReducer";
import productGroupReducer from "./productGroupReducer";
import shopifyShopInfoReducer from "./shopifyShopInfoReducer";
import billingUrlReducer from "./billing-url.reducer";

const rootReducer = combineReducers({
    reviews: reviewsReducer,
    stats: statsReducer,
    settingsData: settingsReducer,
    importReviews: importReviewsReducer,
    pricings: pricingsReducer,
    integrations: integrationReducer,
    questions: questionsReducer,
    onBoardingSteps: onBoardingStepsReducer,
    product: productGroupReducer,
    shopifyShopInfo: shopifyShopInfoReducer,
    billingUrl: billingUrlReducer,
});

export default rootReducer;
